export const LAYOUT_HEADER_HEIGHT = 48;

export const TABS_HEIGHT = 46 + 16; // height + margin-bottom
export const CARD_TABS_HEIGHT = 40;

export const PAGE_HEADER_MIN_HEIGHT = 88;
export const PAGE_HEADER_MAX_HEIGHT = 120;

export const LIST_TABLE_HEADER_MIN_HEIGHT = 32 + 20; // height + margin-bottom
export const LIST_TABLE_ROW_MIN_HEIGHT = 39;

export const PAGE_CONTENT_SPACING = 34;
export const PAGE_WITH_TABS_CONTENT_TOP_SPACING = 12;

// Use for Table with lazy fetch based on scrollY
export const LAZY_TABLE_FULL_PAGE_GUTTER =
  LAYOUT_HEADER_HEIGHT +
  PAGE_HEADER_MIN_HEIGHT +
  PAGE_CONTENT_SPACING +
  PAGE_CONTENT_SPACING +
  LIST_TABLE_HEADER_MIN_HEIGHT;
